import { render, staticRenderFns } from "./Feedbacks.vue?vue&type=template&id=cdc8a2b6"
import script from "./Feedbacks.vue?vue&type=script&lang=js"
export * from "./Feedbacks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports